import { useQuery } from '@tanstack/react-query';
import { tagsApi } from '@/api/tags';
import { queryKeys } from '@/lib/queryKeys';
import { useApiMutation, type MutationCallbacks } from '@/hooks/useApiMutation';
import type { TagRecord } from '@/types/api';

export function useTags({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({ queryKey: queryKeys.tags, queryFn: tagsApi.list, enabled });
}

/** Creates a tag, or renames and recolours `tag` when one is given. Sites show their tags, so they are read again. */
export function useSaveTag(tag: TagRecord | undefined, callbacks?: MutationCallbacks<TagRecord, { name: string; color: string }>) {
  return useApiMutation(
    (input) => (tag ? tagsApi.update(tag.id, input) : tagsApi.create(input)),
    () => [queryKeys.tags, queryKeys.sites.all],
    callbacks,
  );
}

export function useDeleteTag(callbacks?: MutationCallbacks<{ ok: boolean }, TagRecord>) {
  return useApiMutation((tag) => tagsApi.remove(tag.id, tag.siteCount), () => [queryKeys.tags, queryKeys.sites.all], callbacks);
}
